import * as type from "./constants";
import { ISOLanguageCode } from "i18n/resources/supportedLanguages";

export function setLanguage(code: ISOLanguageCode) {
  return {
    code,
    type: type.SET_LANGUAGE
  };
}
